import React from "react";
import { Container, Eyebrow } from "@/components/ui-kit/Section";
import { Reveal } from "@/components/motion/Reveal";

export default function PageHero({ eyebrow, title, subtitle, children, tint = true }) {
  return (
    <section className="relative overflow-hidden pt-32 pb-14 sm:pt-36 sm:pb-16">
      {tint && (
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 -z-10"
          style={{
            background:
              "radial-gradient(55% 45% at 88% 0%, rgba(197,254,237,0.5) 0%, rgba(197,254,237,0) 60%), linear-gradient(180deg, rgba(238,243,248,0.8) 0%, rgba(248,250,252,0) 70%)",
          }}
        />
      )}
      <Container>
        <div className="max-w-3xl">
          <Reveal>
            {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
            <h1 className="mt-4 font-display text-[clamp(2.25rem,4.6vw,3.75rem)] font-extrabold leading-[1.05] tracking-tight text-etap-deep-900">
              {title}
            </h1>
            {subtitle && <p className="mt-5 max-w-2xl text-lg leading-relaxed text-etap-deep-600">{subtitle}</p>}
            {children}
          </Reveal>
        </div>
      </Container>
    </section>
  );
}
